import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import InvalidPermissions from "../company-pages/InvalidPermissions";

import ReportPage from "./ReportPage";

const Report = ({ userPermissions }) => {
	if (userPermissions == "None") return <InvalidPermissions />;

	return (
		<>
			<div>
				<div className="content bg-gray-lighter">
					<div className="row">
						<div className="col-sm-12">
							<div className="pull-left">
								<h1 className="page-heading">Reports</h1>
							</div>
							<div className="pull-right">
								<Link to="/organisation/reports/new">
									<button className="btn btn-success">Add New Report</button>
								</Link>
							</div>
						</div>
					</div>
				</div>
				<div className="content bg-white mb-32">
					<ReportPage />
				</div>
			</div>
		</>
	);
};


const mapStateToProps = (state) => {
  const userPermissions = state?.permissions?.my?.permissions?.reports

    return {
      userPermissions
    }
  }
  
  const mapDispatchToProps = dispatch => ({
  });
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(Report)